"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _ChevronDown = _interopRequireDefault(require("../../../Icons/ChevronDown"));

var _stripUnit = _interopRequireDefault(require("../../../../utils/stripUnit"));

var _spacing = _interopRequireDefault(require("../../../../constants/spacing"));

var _colors = _interopRequireDefault(require("../../../../constants/colors"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\tcolor: ", " !important;\n\t:hover {\n\t\tcursor: pointer;\n\t}\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

var DownIcon = (0, _styledComponents.default)(_ChevronDown.default)(_templateObject(), _colors.default.grey);
DownIcon.displayName = 'DownIcon';
var IconSize = (0, _stripUnit.default)(_spacing.default.s2);

var DownIconComponent = function DownIconComponent(props) {
  return _react.default.createElement(DownIcon, _extends({
    size: IconSize
  }, props));
};

DownIconComponent.displayName = 'DownIcon';
var _default = DownIconComponent;
exports.default = _default;